import { render, staticRenderFns } from "./ImportedActivityStatsSectionPlaceholder.vue?vue&type=template&id=48cbbc4a&scoped=true&"
import script from "./ImportedActivityStatsSectionPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ImportedActivityStatsSectionPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ImportedActivityStatsSectionPlaceholder.vue?vue&type=style&index=0&id=48cbbc4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cbbc4a",
  null
  
)

export default component.exports